<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Licence Keys</p>
          <div class="float-right">
<!--            <Filters />-->
            <el-tooltip content="Insert" placement="top">
              <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click.prevent="insert()"
                  class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Table />
        <Dialog />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
// import Filters from '../components/youtube/keywords/Filters'
import Table from '../components/youtube/keywords/Table'
import Dialog from '../components/youtube/keywords/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    // Filters,
    Table,
    Dialog
  },

  computed: {
    ...mapState('youtubeKeywords', ['loading'])
  },

  methods: {
    ...mapMutations('youtubeKeywords', ['setDialog','setSelectedKeyword']),
    insert() {
      this.setSelectedKeyword({})
      this.setDialog(true)
    }
  }
}
</script>
